import { useEffect } from 'react';

export const useOverscrollBackgroundColor = (color?: string | null) => {
  useEffect(() => {
    let themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (!color) {
      if (themeColorMeta) {
        themeColorMeta.setAttribute('content', '');
      }
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
      const existingStyle = document.getElementById('overscroll-style');
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
      return;
    }

    document.body.style.backgroundColor = color;
    document.documentElement.style.backgroundColor = color;

    if (!themeColorMeta) {
      themeColorMeta = document.createElement('meta');
      themeColorMeta.setAttribute('name', 'theme-color');
      document.head.appendChild(themeColorMeta);
    }
    themeColorMeta.setAttribute('content', color);

    const manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
    if (manifestLink) {
      const updateManifest = async () => {
        try {
          const response = await fetch(manifestLink.href);
          const manifest = await response.json();

          if (manifest.theme_color) {
            manifest.theme_color = color;
            const newManifestUrl = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: 'application/json' }));

            const newManifestLink = document.createElement('link');
            newManifestLink.rel = 'manifest';
            newManifestLink.href = newManifestUrl;

            document.head.removeChild(manifestLink);
            document.head.appendChild(newManifestLink);
          }
        } catch (error) {
          console.error('Error updating manifest:', error);
        }
      };

      updateManifest();
    }

    const style = document.createElement('style');
    style.id = 'overscroll-style';
    style.textContent = `
      html {
        background-color: ${color} !important;
      }
      @supports (-webkit-touch-callout: none) {
        body {
          background-color: ${color} !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';

      const existingStyle = document.getElementById('overscroll-style');
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, [color]);
};
